import { render, staticRenderFns } from "./LoginButtons.vue?vue&type=template&id=40c72de6"
import script from "./LoginButtons.vue?vue&type=script&lang=js"
export * from "./LoginButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports